import { useState } from 'react';
import { MainLayout } from '../components/MainLayout';
import { StatusesManager } from '../components/StatusesManager';
import { ViewSettingsManager } from '../components/ViewSettingsManager';
import { ViewsManager } from '../components/ViewsManager';
import { UsersManager } from '../components/UsersManager';
import { MessageTypesManager } from '../components/MessageTypesManager';
import { ActivitiesManager } from '../components/ActivitiesManager';
import { GroupsManager } from '../components/GroupsManager';
import { BrandingSettings } from '../components/BrandingSettings';
import { ActivityScheduleSettings } from '../components/ActivityScheduleSettings';
import { useLanguage } from '../hooks/useLanguage';

export const Settings = () => {
  const [activeTab, setActiveTab] = useState('statuses');
  const { t } = useLanguage();

  const tabs = [
    { id: 'statuses', name: t('statuses'), icon: '📊' },
    { id: 'views', name: t('views') || 'Views', icon: '🔍' },
    { id: 'activities', name: t('activities') || 'Activities', icon: '🎯' },
    { id: 'groups', name: t('groups') || 'Groups', icon: '👥' },
    { id: 'schedule', name: t('activitySchedule') || 'Activity Schedule', icon: '⏰' },
    { id: 'display', name: t('displaySettings'), icon: '👁️' },
    { id: 'messageTypes', name: t('messageTypes') || 'Message Types', icon: '💬' },
    { id: 'branding', name: t('branding') || 'Branding', icon: '🎨' },
    { id: 'users', name: t('users'), icon: '👤' },
  ];

  return (
    <MainLayout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6">{t('settingsTitle')}</h1>

        {/* Mobile Dropdown */}
        <div className="md:hidden mb-6">
          <label htmlFor="tab-select" className="block text-sm font-medium text-gray-700 mb-2">
            {t('selectCategory') || 'Select Category'}
          </label>
          <select
            id="tab-select"
            value={activeTab}
            onChange={(e) => setActiveTab(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {tabs.map((tab) => (
              <option key={tab.id} value={tab.id}>
                {tab.icon} {tab.name}
              </option>
            ))}
          </select>
        </div>

        {/* Desktop Tabs - Scrollable on smaller screens */}
        <div className="hidden md:block border-b border-gray-200 mb-6">
          <nav className="-mb-px flex overflow-x-auto scrollbar-hide">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`
                  py-4 px-4 border-b-2 font-medium text-sm flex items-center gap-2 whitespace-nowrap flex-shrink-0
                  ${
                    activeTab === tab.id
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }
                `}
              >
                <span>{tab.icon}</span>
                {tab.name}
              </button>
            ))}
          </nav>
        </div>

        {/* Tab Content */}
        <div className="py-6">
          {activeTab === 'statuses' && <StatusesManager />}
          {activeTab === 'views' && <ViewsManager />}
          {activeTab === 'activities' && <ActivitiesManager />}
          {activeTab === 'groups' && <GroupsManager />}
          {activeTab === 'schedule' && <ActivityScheduleSettings />}
          {activeTab === 'display' && <ViewSettingsManager />}
          {activeTab === 'messageTypes' && <MessageTypesManager />}
          {activeTab === 'branding' && <BrandingSettings />}
          {activeTab === 'users' && <UsersManager />}
        </div>
      </div>
    </MainLayout>
  );
};
